module.exports = __webpack_public_path__ + "static/assets/3f47429f747412f292199134a36e744c.png";